export default __webpack_public_path__ + "static/media/icon4.16f0071e.svg";